/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { type ReactNode } from 'react';

export function PresenceListMock(): ReactNode {
	return (
		<div
			style={ {
				fontFamily: 'var(--ck-font-face)'
			} }
			data-skip-in-snippets={ true }
		>
			<div className='ck ck-presence-list ck-reset ck-rounded-corners'>
				<div className='ck ck-presence-list__list'>
					<div
						className='ck ck-presence-list__list-item'
						data-cke-tooltip-text='Zee Croce'
						data-cke-tooltip-classname='ck-presence-list__list-item__tooltip'
						data-cke-tooltip-position='se'
					>
						<div className='ck ck-user ck-user_me'>
							<div className='ck ck-user__name'>ZC</div>
						</div>
					</div>
				</div>
				<div
					className='ck ck-presence-list__counter'
					style={ {
						marginLeft: 'var(--ck-spacing-standard)'
					} }
				>
					1 connected user (me)
				</div>
			</div>
		</div>
	);
}
